<!--
 * @Author: Tina Huang
 * @Date: 2023-06-27 13:10:48
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-06-27 13:12:51
 * @Description: 
-->
<template>
    <layout>
        <router-view />
    </layout>
</template>
<script>
import Layout from '../../components/mobile/Layout.vue'
export default {
  components: { Layout },
}
</script>